import { useAppSelector } from '@shared/store';
import { selectCompanyIds } from '@entities/account';

export const useAccountCompanyIds = () => {
  const companyIds = useAppSelector(selectCompanyIds);

  return companyIds;
};
